{
  "Accessibility Menu": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಮೆನು",
  "Reset settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸಿ",
  "Close": "ಮುಚ್ಚಿ",
  "Content Adjustments": "ವಿಷಯದ ಹೊಂದಾಣಿಕೆಗಳು",
  "Adjust Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಹೊಂದಿಸಿ",
  "Highlight Title": "ಶೀರ್ಷಿಕೆಯನ್ನು ಹೈಲೈಟ್ ಮಾಡಿ",
  "Highlight Links": "ಲಿಂಕ್‌ಗಳನ್ನು ಹೈಲೈಟ್ ಮಾಡಿ",
  "Readable Font": "ಓದಲು ಸುಲಭವಾದ ಅಕ್ಷರಶೈಲಿ",
  "Color Adjustments": "ಬಣ್ಣ ಹೊಂದಾಣಿಕೆಗಳು",
  "Dark Contrast": "ಕತ್ತಲೆ ವ್ಯತ್ಯಾಸ",
  "Light Contrast": "ಹಗುರ ವ್ಯತ್ಯಾಸ",
  "High Contrast": "ಹೆಚ್ಚು ವ್ಯತ್ಯಾಸ",
  "High Saturation": "ಹೆಚ್ಚು ಸಾತುರ್ನತೆ",
  "Low Saturation": "ಕಡಿಮೆ ಸಾತುರ್ನತೆ",
  "Monochrome": "ಏಕವರ್ಣ",
  "Contrast": "ವಿರುದ್ಧತೆ",
  "Invert Colors": "ಬಣ್ಣಗಳನ್ನು ತಿರುಗಿಸಿ",
  "Tools": "ಉಪಕರಣಗಳು",
  "Reading Guide": "ಓದುವ ಮಾರ್ಗದರ್ಶಿ",
  "Stop Animations": "ಅನಿಮೇಶನ್‌ಗಳನ್ನು ನಿಲ್ಲಿಸಿ",
  "Big Cursor": "ದೊಡ್ಡ ಕರ್ಸರ್",
  "Increase Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಹೆಚ್ಚಿಸಿ",
  "Decrease Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಕಡಿಮೆ ಮಾಡಿ",
  "Letter Spacing": "ಅಕ್ಷರಗಳ ನಡುವಿನ ಅಂತರ",
  "Line Height": "ಸಾಲಿನ ಎತ್ತರ",
  "Font Weight": "ಅಕ್ಷರದ ತೂಕ",
  "Dyslexia Font": "ಡಿಸ್ಲೆಕ್ಸಿಯಾ ಅಕ್ಷರಶೈಲಿ",
  "Language": "ಭಾಷೆ",
  "Open Accessibility Menu": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಮೆನು ಅನ್ನು ತೆರೆಯಿರಿ",
  "Widget Settings": "ವಿಜೆಟ್ ಸಂಯೋಜನೆಗಳು",
  "Widget Position": "ವಿಜೆಟ್ ಸ್ಥಾನ",
  "Top Left": "ಮೇಲಿನ ಎಡಭಾಗ",
  "Top Center": "ಮೇಲಿನ ಮಧ್ಯಭಾಗ",
  "Top Right": "ಮೇಲಿನ ಬಲಭಾಗ",
  "Center Left": "ಮಧ್ಯ ಎಡ",
  "Center Right": "ಮಧ್ಯ ಬಲ",
  "Bottom Left": "ಕೆಳ ಎಡ",
  "Bottom Center": "ಕೆಳ ಮಧ್ಯ",
  "Bottom Right": "ಕೆಳ ಬಲ",
  "Screen Reader": "ಸ್ಕ್ರೀನ್ ರೀಡರ್",
  "Voice Navigation": "ಧ್ವನಿ ಸಂಚಲನ",
  "Custom Color": "ವೈಯಕ್ತಿಕ ಬಣ್ಣ",
  "Change the site's colors": "ಸೈಟ್ ಬಣ್ಣಗಳನ್ನು ಬದಲಾಯಿಸಿ",
  "Backgrounds": "ಹಿನ್ನೆಲೆಗಳು",
  "Headings": "ಶೀರ್ಷಿಕೆಗಳು",
  "Contents": "ವಿಷಯಗಳು",
  "Reset colors": "ಬಣ್ಣಗಳನ್ನು ಮರುಹೊಂದಿಸಿ",
  "Image Desaturation": "ಚಿತ್ರದ ಬಣ್ಣ ಕಡಿಮೆ ಮಾಡುವುದು",
  "Search languages": "ಭಾಷೆಗಳನ್ನು ಹುಡುಕಿ",
  "No languages found": "ಯಾವುದೇ ಭಾಷೆಗಳು ಕಂಡುಬರಲಿಲ್ಲ",
  "Accessibility Profiles": "ಅಂಗೀಕಾರ ಪ್ರೊಫೈಲ್‌ಗಳು",
  "Motor Impaired": "ಚಲನಾ ಅಸಮರ್ಥ",
  "Big cursor, voice navigation, and no animations.": "ದೊಡ್ಡ ಕರ್ಸರ್, ಧ್ವನಿ ನಾವಿಗೇಶನ್ ಮತ್ತು ಯಾವುದೇ ಅನಿಮೇಶನ್ ಇಲ್ಲ.",
  "Blind": "ಕುರೂಡು",
  "Screen reader helpers with higher contrast.": "ಹೆಚ್ಚಿನ ಕಾಂಟ್ರಾಸ್ಟ್ ಇರುವ ಸ್ಕ್ರೀನ್ ರೀಡರ್ ನೆರವು.",
  "Color Blind": "ಬಣ್ಣಾಂಧ",
  "High contrast palette with desaturated media.": "ಹೆಚ್ಚಿನ ಕಾಂಟ್ರಾಸ್ಟ್ ಪ್ಯಾಲೆಟ್ ಮತ್ತು ಕಡಿಮೆ ಸ್ಯಾಚುरेशन ಮೀಡಿಯಾ.",
  "Dyslexia": "ಡಿಸ್ಲೆಕ್ಸಿಯಾ",
  "Friendly font, extra spacing, stronger weight.": "ಸುಲಭ ಓದಬಹುದಾದ ಫಾಂಟ್, ಹೆಚ್ಚುವರಿ ಅಂತರ ಮತ್ತು ಗಟ್ಟಿದಷ್ಟು ದಪ್ಪ.",
  "Low vision": "ಕಡಿಮೆ ದೃಷ್ಟಿ",
  "Dark contrast and 130% magnification.": "ಗಾಢ ಕಾಂಟ್ರಾಸ್ಟ್ ಮತ್ತು 130% ಹಿಗ್ಗು.",
  "Cognitive & Learning": "ಜ್ಞಾನಾತ್ಮಕ ಮತ್ತು ಕಲಿಕೆ",
  "Highlights key sections and enables voice help.": "ಮುಖ್ಯ ವಿಭಾಗಗಳನ್ನು ಹೊಳೆಯಿಸಿ ಮತ್ತು ಧ್ವನಿ ಸಹಾಯವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸುತ್ತದೆ.",
  "Seizure & Epileptic": "ಅಪಸ್ಮಾರ ಮತ್ತು ಎಪಿಲೆಪ್ಸಿ",
  "Stops animations and desaturates imagery.": "ಅನಿಮೇಶನ್‌ಗಳನ್ನು ನಿಲ್ಲಿಸಿ ಚಿತ್ರಗಳ ಸ್ಯಾಚುರೇಶನ್ ಕಡಿಮೆ ಮಾಡುತ್ತದೆ.",
  "ADHD": "ಎಡಿಎಚ್ಡಿ",
  "Reading guide, highlighted links, calmer palette.": "ಓದುವ ಮಾರ್ಗದರ್ಶಿ, ಹೈಲೈಟ್ ಮಾಡಿದ ಲಿಂಕುಗಳು ಮತ್ತು ಶಾಂತ ಪ್ಯಾಲೆಟ್.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
